import React from 'react';
import { Path } from 'react-native-svg';
import SVGIcon from './SVGIcon';
import withDefaultIconProps from './withDefaultIconProps';
const DeleteIcon = ({ color, ...rest }) => {
    return (React.createElement(SVGIcon, { ...rest },
        React.createElement(Path, { d: "M6.5 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7h-12v12zm13-15H16l-1-1h-5L9 4H5.5v2h14V4z", fill: color })));
};
export default withDefaultIconProps(DeleteIcon);
